import { DivTooltip, Highlighter, Tooltip, TooltipBody } from "@wg/wows-react-uikit";
import classNames from "classnames";
import React, { PureComponent } from "react";
import Medal from "../Medal/Medal";
import styles from "./ResultsHeader.scss";

const needMedal = false;

export interface ResultsHeaderProps {
    medalData: any,
    params: any,
    withMedal?: boolean
}

class ResultsHeader extends PureComponent<ResultsHeaderProps> {
    render() {
        return (
            <div className={styles.container}>
                {(this.props.medalData && needMedal) && <div className={styles.medal}>
                    <Medal size="medium" league={this.props.medalData.number} points={this.props.medalData.points} />
                </div>}
                {(this.props.params && this.props.params.length) && this.props.params.map((param, index) => {
                    return <div className={styles.headerParam} key={`HeaderParam_${index}`}>
                        <DivTooltip className={classNames(styles.headerParamValue, param.type && styles.type, param.type && styles[param.type])} tooltipBody={<Tooltip>
                            <TooltipBody>
                                {param.tooltipBody}
                            </TooltipBody>
                        </Tooltip>}>
                            <div>
                                <Highlighter className={styles.headerParamValue} value={param.value} />
                            </div>
                        </DivTooltip>
                        <span className={styles.headerParamLabel}>{`${param.label}`}</span>
                    </div>;
                })}
            </div>
        )
    }
}

export default ResultsHeader;